import { IOrderStatus, IPreorderStatus } from 'my-poppies-b2b-types';
import { useContext } from 'react';

import { Container } from '@/components/Container';
import { OrderApproveDeclineButtons } from '@/components/Order/buildingBlocks/OrderApproveDeclineButtons';
import { OrderCancelButton } from '@/components/Order/buildingBlocks/OrderCancelButton';
import { OrderEditButton } from '@/components/Order/buildingBlocks/OrderEditButton';
import { SettingsContext } from '@/contexts/SettingsContext';
import { OrderRedirectButton } from './OrderRedirectButton';

interface IOrderButtonSectionProps {
  id: string;
  status: IOrderStatus | IPreorderStatus;
  customerId?: string;
}

export const OrderButtonSection = ({ id, status, customerId }: IOrderButtonSectionProps) => {
  const {
    isCurrentUserRoleAllowedToEditOrders,
    isCurrentUserRoleAllowedToRedirectShippedOrders,
    isCurrentUserRoleAllowedToApproveOrDeclineOrders,
    isCurrentUserRoleAllowedToCancelOrders,
  } = useContext(SettingsContext);

  const showEditButton = isCurrentUserRoleAllowedToEditOrders && ['NEW', 'DECLINED'].includes(status);
  const showRedirectButton = isCurrentUserRoleAllowedToRedirectShippedOrders && status === 'SHIPPED';
  const showApproveDeclineButtons =
    isCurrentUserRoleAllowedToApproveOrDeclineOrders && (status === 'NEW' || status === 'DECLINED');
  const showCancelButton =
    isCurrentUserRoleAllowedToCancelOrders && (status === 'BEING_PREPARED' || status === 'SHIPPED');

  if (!showEditButton && !showRedirectButton && !showApproveDeclineButtons && !showCancelButton) {
    return null;
  }

  return (
    <Container
      debugColor={'orange'}
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: '12px', marginTop: '8px' }}
    >
      {showEditButton && <OrderEditButton orderId={id} status={status} />}
      {showCancelButton && <OrderCancelButton orderId={id} status={status} />}
      {showRedirectButton && (
        <OrderRedirectButton orderId={id} customerId={customerId} status={status as IOrderStatus} />
      )}
      {showApproveDeclineButtons && <OrderApproveDeclineButtons orderId={id} isOrderDeclined={status === 'DECLINED'} />}
    </Container>
  );
};
